// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hB2md","newExpiryDate":"styles_newExpiryDate__19jVH","footer":"styles_footer__SvDrV"};